import { render, staticRenderFns } from "./BnplTransactionRow.vue?vue&type=template&id=594d16be&scoped=true&"
import script from "./BnplTransactionRow.vue?vue&type=script&lang=js&"
export * from "./BnplTransactionRow.vue?vue&type=script&lang=js&"
import style0 from "./BnplTransactionRow.vue?vue&type=style&index=0&id=594d16be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594d16be",
  null
  
)

export default component.exports